/* NUVORA — interacciones. Vanilla, sin librerías. */
(function () {
  'use strict';

  var sinMovimiento = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Animaciones de entrada (un solo observador para toda la página) --- */
  function initReveals() {
    var els = document.querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!els.length) return;
    if (sinMovimiento || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('mt-visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* --- Selector de zonas de calor --- */
  function initZonas() {
    var bloques = document.querySelectorAll('[data-mt-zonas]');
    if (!bloques.length) return;
    bloques.forEach(function (bloque) {
      var tabs = bloque.querySelectorAll('.mt-zonas__tab');
      var paneles = bloque.querySelectorAll('.mt-zonas__panel');
      if (!tabs.length || !paneles.length) return;

      function activar(idx) {
        tabs.forEach(function (t, i) {
          t.setAttribute('aria-selected', i === idx ? 'true' : 'false');
        });
        paneles.forEach(function (p, i) {
          p.classList.toggle('is-on', i === idx);
        });
      }
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { activar(i); });
        tab.addEventListener('keydown', function (ev) {
          if (ev.key === 'ArrowRight') { activar((i + 1) % tabs.length); tabs[(i + 1) % tabs.length].focus(); }
          if (ev.key === 'ArrowLeft') { var p = (i - 1 + tabs.length) % tabs.length; activar(p); tabs[p].focus(); }
        });
      });
      activar(0);
    });
  }

  /* --- Marquesina de reseñas: duplica el contenido para el bucle --- */
  function initResenas() {
    var pistas = document.querySelectorAll('.mt-res__pista:not([data-mt-lista])');
    if (!pistas.length) return;
    pistas.forEach(function (pista) {
      pista.setAttribute('data-mt-lista', '1');
      var originales = Array.prototype.slice.call(pista.children);
      if (!originales.length) return;
      originales.forEach(function (n) {
        var copia = n.cloneNode(true);
        copia.setAttribute('aria-hidden', 'true');
        pista.appendChild(copia);
      });
    });
  }

  /* --- Cifras que suben al entrar en pantalla --- */
  function initCifras() {
    var cifras = document.querySelectorAll('[data-mt-cifra]:not([data-mt-hecho])');
    if (!cifras.length) return;
    if (sinMovimiento || !('IntersectionObserver' in window)) {
      cifras.forEach(function (el) { el.textContent = el.getAttribute('data-mt-cifra'); });
      return;
    }
    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        obs.unobserve(el);
        el.setAttribute('data-mt-hecho', '1');
        var fin = parseFloat(el.getAttribute('data-mt-cifra')) || 0;
        var ini = performance.now(), dur = 1400;
        (function paso(t) {
          var p = Math.min((t - ini) / dur, 1);
          var e2 = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(fin * e2);
          if (p < 1) requestAnimationFrame(paso);
          else el.textContent = fin;
        })(ini);
      });
    }, { threshold: 0.5 });
    cifras.forEach(function (el) { obs.observe(el); });
  }


  /* --- Página de producto: galería + selección de variante --- */
  function initProducto() {
    var bloques = document.querySelectorAll('[data-mt-producto]:not([data-mt-listo])');
    if (!bloques.length) return;

    bloques.forEach(function (raiz) {
      raiz.setAttribute('data-mt-listo', '1');

      /* Galería: miniaturas cambian la foto principal */
      var principal = raiz.querySelector('.mt-prod__principal img');
      var minis = raiz.querySelectorAll('.mt-prod__mini');
      minis.forEach(function (mini) {
        mini.addEventListener('click', function () {
          var src = mini.getAttribute('data-mt-foto');
          if (src && principal) principal.src = src;
          minis.forEach(function (m) { m.setAttribute('aria-current', m === mini ? 'true' : 'false'); });
        });
      });

      /* Variantes */
      var datos = raiz.querySelector('[data-mt-variantes]');
      if (!datos) return;
      var variantes;
      try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
      if (!variantes || !variantes.length) return;

      var grupos = raiz.querySelectorAll('[data-mt-opcion]');
      var campoId = raiz.querySelector('[data-mt-id]');
      var elPrecio = raiz.querySelector('[data-mt-precio]');
      var elAntes = raiz.querySelector('[data-mt-antes]');
      var elOff = raiz.querySelector('[data-mt-off]');
      var botonAdd = raiz.querySelector('[data-mt-anadir]');
      var textoAdd = raiz.querySelector('[data-mt-anadir-txt]');
      var barra = document.querySelector('[data-mt-barra]');
      var barraPrecio = document.querySelector('[data-mt-barra-precio]');
      var barraVar = document.querySelector('[data-mt-barra-variante]');
      var barraBtn = document.querySelector('[data-mt-barra-btn]');
      var etiquetaAdd = textoAdd ? textoAdd.textContent.trim() : 'Añadir al carrito';

      function seleccion() {
        var sel = [];
        grupos.forEach(function (g) {
          var lista = g.querySelector('[data-mt-lista]');
          if (lista) { sel.push(lista.value); return; }
          var activo = g.querySelector('[aria-pressed="true"]');
          sel.push(activo ? activo.getAttribute('data-mt-valor') : null);
        });
        return sel;
      }

      function buscar(sel) {
        for (var i = 0; i < variantes.length; i++) {
          var v = variantes[i], igual = true;
          for (var j = 0; j < sel.length; j++) {
            if (v.opciones[j] !== sel[j]) { igual = false; break; }
          }
          if (igual) return v;
        }
        return null;
      }

      function refrescar() {
        var sel = seleccion();
        grupos.forEach(function (g) {
          var eco = g.querySelector('[data-mt-elegido]');
          if (!eco) return;
          var lista = g.querySelector('[data-mt-lista]');
          if (lista) { eco.textContent = lista.value; return; }
          var activo = g.querySelector('[aria-pressed="true"]');
          if (activo) eco.textContent = activo.textContent.trim();
        });

        var v = buscar(sel);
        if (!v) {
          if (botonAdd) { botonAdd.disabled = true; }
          if (textoAdd) textoAdd.textContent = 'Combinación no disponible';
          return;
        }
        if (campoId) campoId.value = v.id;
        if (elPrecio) elPrecio.textContent = v.precio_txt;

        /* La galería salta a la foto de la variante elegida */
        if (v.foto && principal && principal.src !== v.foto) {
          principal.src = v.foto;
          {
            minis.forEach(function (m) {
              var suya = m.getAttribute('data-mt-foto');
              m.setAttribute('aria-current', suya === v.foto ? 'true' : 'false');
            });
            var activa = raiz.querySelector('.mt-prod__mini[aria-current="true"]');
            if (activa && activa.scrollIntoView) {
              activa.scrollIntoView({ block: 'nearest', inline: 'nearest' });
            }
          }
        }

        var hayAntes = v.antes && Number(v.antes) > Number(v.precio);
        if (elAntes) {
          if (hayAntes) { elAntes.textContent = v.antes_txt; elAntes.hidden = false; }
          else { elAntes.hidden = true; }
        }
        if (elOff) {
          if (hayAntes) {
            var pct = Math.round((Number(v.antes) - Number(v.precio)) * 100 / Number(v.antes));
            elOff.textContent = '-' + pct + ' %';
            elOff.hidden = false;
          } else { elOff.hidden = true; }
        }
        if (botonAdd) botonAdd.disabled = !v.disponible;
        if (textoAdd) textoAdd.textContent = v.disponible ? etiquetaAdd : 'Agotado temporalmente';
        if (barraPrecio) barraPrecio.textContent = v.precio_txt;
        if (barraVar) barraVar.textContent = sel.join(' · ');
        if (barraBtn) {
          barraBtn.disabled = !v.disponible;
          barraBtn.textContent = v.disponible ? etiquetaAdd : 'Agotado';
        }

        /* Refleja la variante en la URL, como hace Shopify */
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u);
        } catch (e) {}
      }

      grupos.forEach(function (g) {
        var lista = g.querySelector('[data-mt-lista]');
        if (lista) {
          lista.addEventListener('change', refrescar);
          return;
        }
        g.querySelectorAll('[data-mt-valor]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            g.querySelectorAll('[data-mt-valor]').forEach(function (b) {
              b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
            });
            refrescar();
          });
        });
      });

      refrescar();

      /* La barra fija aparece cuando el botón principal sale de pantalla */
      if (barra && botonAdd) {
        if (barraBtn) {
          barraBtn.addEventListener('click', function () {
            var f = botonAdd.closest('form');
            if (!f) return;
            if (f.requestSubmit) f.requestSubmit(botonAdd); else botonAdd.click();
          });
        }
        /* Se muestra cuando el botón principal ya no está a la vista.
           Con listener de scroll (no IntersectionObserver): es predecible
           y funciona igual con scroll del usuario o programático. */
        var ultimaRevision = 0;
        function revisarBarra() {
          ultimaRevision = Date.now();
          var r = botonAdd.getBoundingClientRect();
          var fuera = r.bottom < 90 || r.top > window.innerHeight;
          barra.classList.toggle('is-on', fuera);
        }
        function alHacerScroll() {
          /* Limitado por tiempo, no por requestAnimationFrame: rAF se pausa
             cuando la pestaña no está visible y la barra se quedaba encallada. */
          var ahora = Date.now();
          if (ahora - ultimaRevision < 80) return;
          revisarBarra();
        }
        window.addEventListener('scroll', alHacerScroll, { passive: true });
        window.addEventListener('resize', alHacerScroll, { passive: true });
        revisarBarra();
      }
    });
  }

  function initTodo() {
    initReveals();
    initZonas();
    initResenas();
    initCifras();
    initProducto();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTodo);
  } else {
    initTodo();
  }
  /* El editor de Shopify recarga secciones sueltas: re-inicializa */
  document.addEventListener('shopify:section:load', initTodo);
})();
